const menuButtons=[...document.querySelectorAll('[data-menu]')];
const mobileToggle=document.querySelector('.mobile-menu-toggle');
const nav=document.querySelector('.meganav');
function closeMenus(){menuButtons.forEach(b=>{b.dataset.hoverOpened='false';b.setAttribute('aria-expanded','false');document.getElementById(b.getAttribute('aria-controls')).hidden=true;});}
function openMenu(button){closeRewards();closeMenus();button.setAttribute('aria-expanded','true');document.getElementById(button.getAttribute('aria-controls')).hidden=false;}
menuButtons.forEach(button=>{
 button.addEventListener('click',()=>{if(button.dataset.hoverOpened==='true'){button.dataset.hoverOpened='false';return;}const open=button.getAttribute('aria-expanded')==='true';closeMenus();if(!open)openMenu(button);});
 button.closest('.nav-item').addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&innerWidth>700){openMenu(button);button.dataset.hoverOpened='true';}});
});
document.querySelector('.v2-header').addEventListener('pointerleave',()=>{if(innerWidth>700)closeMenus();});
document.addEventListener('click',e=>{if(!e.target.closest('.v2-header')){closeMenus();nav.classList.remove('mobile-open');mobileToggle.setAttribute('aria-expanded','false');}});
document.querySelector('.v2-header').addEventListener('focusout',e=>{if(!e.currentTarget.contains(e.relatedTarget))closeMenus();});
mobileToggle.addEventListener('click',()=>{const open=nav.classList.toggle('mobile-open');if(open){closeRewards();if(quickResources)quickResources.open=false;}mobileToggle.setAttribute('aria-expanded',String(open));mobileToggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');if(!open)closeMenus();});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!document.querySelector('dialog[open]')){const active=menuButtons.find(b=>b.getAttribute('aria-expanded')==='true');closeMenus();if(active)active.focus();else if(nav.classList.contains('mobile-open')){nav.classList.remove('mobile-open');mobileToggle.setAttribute('aria-expanded','false');mobileToggle.focus();}}});
const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)');
const benefitPause=document.querySelector('.benefit-pause');
benefitPause?.addEventListener('click',()=>{const paused=benefitPause.closest('.live-benefit-slider').classList.toggle('is-paused');benefitPause.setAttribute('aria-pressed',String(paused));benefitPause.setAttribute('aria-label',paused?'Play benefits slider':'Pause benefits slider');benefitPause.textContent=paused?'â–¶':'â…¡';});
let opener;
document.querySelectorAll('dialog.video-dialog').forEach(dialog=>{
 const close=()=>dialog.close();dialog.querySelector('.dialog-close').addEventListener('click',close);
 dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
 dialog.addEventListener('close',()=>{dialog.querySelector('.video-player')?.replaceChildren();document.body.style.overflow='';opener?.focus();});
});
document.querySelectorAll('[data-video]').forEach(button=>button.addEventListener('click',()=>{
 opener=button;const dialog=document.querySelector('.video-dialog');const frame=document.createElement('iframe');frame.src=`https://www.tiktok.com/player/v1/${button.dataset.video}?autoplay=1&loop=0&rel=0&native_context_menu=0`;frame.title=`${button.dataset.title} by @${button.dataset.author}`;frame.allow='autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen=true;dialog.querySelector('.video-player').replaceChildren(frame);dialog.querySelector('.video-original').href=`https://www.tiktok.com/@${button.dataset.author}/video/${button.dataset.video}`;dialog.showModal();document.body.style.overflow='hidden';dialog.querySelector('.dialog-close').focus();
}));


const rewardsRoot=document.querySelector('.compact-rewards');
const rewardsTrigger=rewardsRoot?.querySelector('.rewards-trigger');
const rewardsPanel=rewardsRoot?.querySelector('.rewards-panel');
let rewardsHoverOpened=false;
function closeRewards(){if(!rewardsRoot)return;rewardsTrigger.setAttribute('aria-expanded','false');rewardsPanel.hidden=true;rewardsHoverOpened=false;}
function openRewards(){closeMenus();rewardsTrigger.setAttribute('aria-expanded','true');rewardsPanel.hidden=false;}
rewardsTrigger?.addEventListener('click',()=>{if(rewardsHoverOpened){rewardsHoverOpened=false;return;}if(rewardsTrigger.getAttribute('aria-expanded')==='true')closeRewards();else openRewards();});
rewardsRoot?.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&matchMedia('(min-width:701px) and (hover:hover)').matches){openRewards();rewardsHoverOpened=true;}});
rewardsRoot?.addEventListener('pointerleave',()=>{if(innerWidth>700&&!rewardsRoot.contains(document.activeElement))closeRewards();});
rewardsRoot?.addEventListener('focusout',e=>{if(!rewardsRoot.contains(e.relatedTarget))closeRewards();});
document.addEventListener('click',e=>{if(!e.target.closest('.compact-rewards'))closeRewards();});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&rewardsTrigger?.getAttribute('aria-expanded')==='true'){closeRewards();rewardsTrigger.focus();}});

function alignBibleTitles(){
 const titles=[...document.querySelectorAll('#bibles .home-soft-card:not([hidden]) h3')];
 titles.forEach(t=>t.style.minHeight='0');
 const height=Math.ceil(Math.max(0,...titles.map(t=>t.getBoundingClientRect().height)));
 titles.forEach(t=>t.style.minHeight=`${height}px`);
}
function alignApparelTitles(){
 const titles=[...document.querySelectorAll('.apparel-soft-card:not([hidden]) h3')];
 titles.forEach(t=>t.style.minHeight='0');
 const height=Math.ceil(Math.max(0,...titles.map(t=>t.getBoundingClientRect().height)));
 titles.forEach(t=>t.style.minHeight=`${height}px`);
}
const quickResources=document.querySelector('.quick-resources');
quickResources?.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){quickResources.open=true;quickResources.dataset.hoverOpened='true';}});
quickResources?.addEventListener('pointerleave',()=>{if(!quickResources.contains(document.activeElement))quickResources.open=false;});
quickResources?.addEventListener('focusout',e=>{if(!quickResources.contains(e.relatedTarget))quickResources.open=false;});
document.addEventListener('click',e=>{if(quickResources&&!quickResources.contains(e.target))quickResources.open=false;});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&quickResources?.open){quickResources.open=false;quickResources.querySelector('summary').focus();}});
const featureRotator=document.querySelector('.feature-rotator');
if(featureRotator){
 const callouts=[...featureRotator.querySelectorAll('.feature-callout')];let index=0;
 setInterval(()=>{if(document.hidden||reduceMotion.matches)return;callouts[index].hidden=true;index=(index+1)%callouts.length;callouts[index].hidden=false;},4000);
}

quickResources?.querySelector('summary').addEventListener('click',e=>{if(quickResources.dataset.hoverOpened==='true'){e.preventDefault();quickResources.dataset.hoverOpened='false';}});

const phoneLayout=matchMedia('(max-width:700px)');
const footerGroups=[...document.querySelectorAll('.footer-col')];
const menuGroups=[...document.querySelectorAll('.mega-group')];
const phoneFaqContact=document.querySelector('#faq .faq-contact');
const originalFaqContactParent=phoneFaqContact.parentElement;
function configurePhoneLayout(){
 if(phoneLayout.matches)document.querySelector('#faq').append(phoneFaqContact);
 else originalFaqContactParent.append(phoneFaqContact);
 footerGroups.forEach(group=>{group.open=!phoneLayout.matches;group.querySelector('summary').tabIndex=phoneLayout.matches?0:-1;});
 menuGroups.forEach(group=>{
  const first=group===group.parentElement.querySelector('.mega-group');
  const expanded=!phoneLayout.matches||first;
  group.querySelector('.mega-group-toggle').setAttribute('aria-expanded',String(expanded));
  group.querySelector('.mega-group-links').classList.toggle('mobile-collapsed',!expanded);
 });
 if(!phoneLayout.matches){document.body.classList.remove('mobile-navigation-open');nav.classList.remove('mobile-open');mobileToggle.setAttribute('aria-expanded','false');closeMenus();}
 alignBibleTitles();alignApparelTitles();
}
menuGroups.forEach(group=>group.querySelector('.mega-group-toggle').addEventListener('click',()=>{
 const button=group.querySelector('.mega-group-toggle');
 const expanded=button.getAttribute('aria-expanded')!=='true';
 button.setAttribute('aria-expanded',String(expanded));
 group.querySelector('.mega-group-links').classList.toggle('mobile-collapsed',!expanded);
}));
function syncPhoneNavigation(){
 const open=phoneLayout.matches&&nav.classList.contains('mobile-open');
 document.body.classList.toggle('mobile-navigation-open',open);
 mobileToggle.setAttribute('aria-label',open?'Close navigation':'Open navigation');
 document.querySelectorAll('main,footer,.review-bar,.compact-rewards,.feature-bar,.mobile-category-navigation').forEach(region=>region.inert=open);
 if(open)document.documentElement.style.setProperty('--mobile-nav-top',`${Math.ceil(document.querySelector('.v2-header').getBoundingClientRect().bottom)}px`);
}
new MutationObserver(syncPhoneNavigation).observe(nav,{attributes:true,attributeFilter:['class']});
window.addEventListener('resize',syncPhoneNavigation);
phoneLayout.addEventListener('change',configurePhoneLayout);
configurePhoneLayout();
footerGroups.forEach(group=>group.querySelector('summary').addEventListener('click',e=>{if(!phoneLayout.matches)e.preventDefault();}));
document.addEventListener('keydown',e=>{
 if(e.key!=='Tab'||!document.body.classList.contains('mobile-navigation-open'))return;
 const focusable=[...document.querySelector('.v2-header').querySelectorAll('a[href],button,summary')].filter(el=>el.getBoundingClientRect().width>0&&!el.disabled&&el.tabIndex>=0);
 const first=focusable[0],last=focusable.at(-1);
 if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
 else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
});



// Cache one server-rendered response per editor section, never product snapshots.
const homepageCollectionResponses = new Map();
async function loadHomepageCollection(section, value, bible, signal){
 const rail=section.querySelector('[data-rail]');
 const key=bible?'filterGroup':'category';
 if([...rail.children].some(card=>card.dataset[key]===value))return;
 const id=section.dataset.collectionSectionId;if(!id)return;
 if(!homepageCollectionResponses.has(id)){
  const url=new URL(window.location.pathname,window.location.origin);
  url.searchParams.set('section_id',id);
  // Explicit preview identity is preserved when it is still in the URL.
  const preview=new URLSearchParams(window.location.search).get('preview_theme_id');
  if(preview)url.searchParams.set('preview_theme_id',preview);
  const request=fetch(url,{credentials:'same-origin'}).then(async response=>{
   if(!response.ok)throw new Error('Collection response unavailable');
   const document=new DOMParser().parseFromString(await response.text(),'text/html');
   if(!document.querySelector('[data-collection-section-id]'))throw new Error('Collection section missing');
   return document;
  }).catch(error=>{homepageCollectionResponses.delete(id);throw error;});
  homepageCollectionResponses.set(id,request);
 }
 const document=await homepageCollectionResponses.get(id);
 if(signal.aborted||!rail.isConnected)return;
 const source=document.querySelector(bible?'[data-product-section] [data-rail]':'[data-apparel-section] [data-rail]');
 const matches=[...source.children].filter(card=>card.dataset[key]===value);
 if(!matches.length)throw new Error('No products in this collection');
 // A second click may have awaited the same response; avoid duplicate cards.
 if(![...rail.children].some(card=>card.dataset[key]===value)){
  const fragment=window.document.createDocumentFragment();
  matches.forEach(card=>fragment.append(card.cloneNode(true)));rail.append(fragment);
  initializeHomepageContent(section);
 }
}
const homepageContentCleanup = new WeakMap();
function initializeHomepageContent(root=document){
 root.querySelectorAll('[data-carousel]').forEach(section=>{
  if(homepageContentCleanup.has(section))return;
  const rail=section.querySelector('[data-rail]');if(!rail)return;
  const controller=new AbortController(), observers=[];
  const listen=(el,type,fn,options={})=>el?.addEventListener(type,fn,{...options,signal:controller.signal});
  const previous=section.querySelector('[data-prev]'),next=section.querySelector('[data-next]');
  const align=()=>{if(section.id==='bibles')alignBibleTitles();else if(section.hasAttribute('data-apparel-section'))alignApparelTitles();};
  const sync=()=>{const max=rail.scrollWidth-rail.clientWidth;if(previous)previous.disabled=rail.scrollLeft<=2;if(next)next.disabled=max<=1||rail.scrollLeft>=max-2;};
  const move=direction=>{const card=[...rail.children].find(c=>!c.hidden);const step=card?card.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap||'0'):rail.clientWidth;rail.scrollTo({left:Math.max(0,Math.min(rail.scrollWidth-rail.clientWidth,rail.scrollLeft+direction*step)),behavior:reduceMotion.matches?'instant':'smooth'});};
  listen(previous,'click',()=>move(-1));listen(next,'click',()=>move(1));
  listen(rail,'scroll',sync,{passive:true});
  listen(rail,'keydown',e=>{if(e.target===rail&&(e.key==='ArrowRight'||e.key==='ArrowLeft')){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
  let selection=0;
  section.querySelectorAll('[data-filter],[data-apparel-filter]').forEach(button=>listen(button,'click',async()=>{
   const bible=button.hasAttribute('data-filter'),selector=bible?'[data-filter]':'[data-apparel-filter]',value=bible?button.dataset.filter:button.dataset.apparelFilter;
   const current=++selection,status=section.querySelector('.collection-load-status');
   section.querySelectorAll(selector).forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   rail.setAttribute('aria-busy','true');if(status)status.textContent='Loading collection…';
   try{
    await loadHomepageCollection(section,value,bible,controller.signal);
    if(current!==selection||controller.signal.aborted)return;
    rail.querySelectorAll(bible?'[data-translation]':'[data-category]').forEach(card=>{card.hidden=(bible?card.dataset.filterGroup:card.dataset.category)!==value;});
    align();rail.scrollTo({left:0,behavior:'instant'});sync();if(status)status.textContent='';
   }catch(error){
    if(current!==selection||controller.signal.aborted)return;
    // Keep the previous usable collection visible and provide an actual link.
    const visible=[...rail.children].find(card=>!card.hidden),previousValue=visible?.dataset[bible?'filterGroup':'category'];
    section.querySelectorAll(selector).forEach(b=>b.setAttribute('aria-pressed',String((bible?b.dataset.filter:b.dataset.apparelFilter)===previousValue)));
    if(status){status.replaceChildren();const link=document.createElement('a');link.href=section.querySelector('.collection-shop-cta').href;link.textContent='Browse the full collection ';link.insertAdjacentHTML('beforeend','<svg class="ss-link-arrow" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 18 18 6M6 6h12v12"/></svg>');status.append(link);}
   }finally{if(current===selection)rail.removeAttribute('aria-busy');}
  }));
  let lastWidth=-1;
  const resize=new ResizeObserver(entries=>{const width=entries[0].contentRect.width;if(width!==lastWidth){lastWidth=width;align();}sync();});resize.observe(rail);observers.push(resize);
  const mutation=new MutationObserver(sync);mutation.observe(rail,{subtree:true,attributes:true,attributeFilter:['hidden']});observers.push(mutation);
  document.fonts.ready.then(()=>{if(rail.isConnected)align();});align();sync();
  homepageContentCleanup.set(section,()=>{controller.abort();observers.forEach(observer=>observer.disconnect());homepageContentCleanup.delete(section);});
 });
 root.querySelectorAll('.translation-options').forEach(options=>{
  if(homepageContentCleanup.has(options))return;
  const plus=options.querySelector('.translation-plus'),panel=options.querySelector('.more-translations-panel');if(!plus||!panel)return;
  const controller=new AbortController();let timer;
  const listen=(el,type,fn)=>el.addEventListener(type,fn,{signal:controller.signal});
  const setOpen=open=>{clearTimeout(timer);plus.setAttribute('aria-expanded',String(open));panel.hidden=!open;};
  listen(plus,'click',()=>setOpen(panel.hidden));
  [plus,panel].forEach(el=>{listen(el,'pointerenter',e=>{if(e.pointerType==='mouse'&&matchMedia('(min-width:701px) and (hover:hover)').matches)setOpen(true);});listen(el,'pointerleave',()=>{timer=setTimeout(()=>{if(!options.contains(document.activeElement))setOpen(false);},180);});});
  listen(options,'focusout',e=>{if(!options.contains(e.relatedTarget))setOpen(false);});
  listen(document,'click',e=>{if(!options.contains(e.target))setOpen(false);});
  listen(document,'keydown',e=>{if(e.key==='Escape'&&!panel.hidden){setOpen(false);plus.focus();}});
  homepageContentCleanup.set(options,()=>{clearTimeout(timer);controller.abort();homepageContentCleanup.delete(options);});
 });
 root.querySelectorAll('.home-card-reviews').forEach(widget=>{
  if(homepageContentCleanup.has(widget))return;
  const format=()=>{
   const badge=widget.querySelector('.jdgm-prev-badge');if(!badge)return;
   const average=Number(badge.dataset.averageRating),count=Number(badge.dataset.numberOfReviews),text=badge.querySelector('.jdgm-prev-badge__text');
   if(!text||!Number.isFinite(average)||!Number.isFinite(count)||count<=0)return;
   const summary=`${average.toFixed(1)} (${count})`;if(text.textContent!==summary)text.textContent=summary;
   badge.setAttribute('aria-label',`Rated ${average.toFixed(1)} out of 5 from ${count} reviews`);
  };
  format();const observer=new MutationObserver(format);observer.observe(widget,{childList:true,subtree:true,attributes:true,attributeFilter:['data-average-rating','data-number-of-reviews']});
  homepageContentCleanup.set(widget,()=>{observer.disconnect();homepageContentCleanup.delete(widget);});
 });
}
initializeHomepageContent();
if(window.Shopify?.designMode){
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-carousel],.translation-options,.home-card-reviews').forEach(el=>homepageContentCleanup.get(el)?.()));
 document.addEventListener('shopify:section:load',event=>{homepageCollectionResponses.clear();initializeHomepageContent(event.target);});
}

// Footer offer: native Shopify signup and immediate code delivery.
function initializeHomepageOffer(){
 const button=document.querySelector('[data-open-offer]'),dialog=document.getElementById('SSOfferDialog');
 if(!button||!dialog||button.dataset.offerInitialized)return;
 button.dataset.offerInitialized='true';
 const open=()=>{
  if(!dialog.open)dialog.showModal();
  // Keep focus in the tap event so mobile Safari can open the keyboard.
  (dialog.querySelector('input[type="email"]')||dialog.querySelector('[data-offer-use]')||dialog.querySelector('[data-close-offer]'))?.focus({preventScroll:true});
 };
 button.addEventListener('click',open);
 dialog.querySelector('[data-close-offer]').addEventListener('click',()=>dialog.close());
 dialog.addEventListener('click',event=>{if(event.target===dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
 dialog.addEventListener('close',()=>button.focus({preventScroll:true}));
 const form=dialog.querySelector('form');
 form?.addEventListener('submit',()=>{
  // Shopify can show a verification challenge outside the dialog.
  // Release the top layer so the challenge remains visible and usable.
  dialog.close();
 });
 if(dialog.querySelector('[data-offer-success],[data-offer-errors]'))open();
}
initializeHomepageOffer();

// Explicit offer link from another storefront page.
if(new URLSearchParams(location.search).get('offer')==='5'){document.querySelector('[data-open-offer]')?.click();}

/* Shared cart quantity: update after successful cart changes. */
(()=>{
 const link=document.querySelector('[data-ss-cart-link]');
 const badge=link?.querySelector('[data-ss-cart-count]');
 if(!badge||window.__ssCartCountInitialized)return;
 window.__ssCartCountInitialized=true;
 const originalFetch=window.fetch;
 let timer,requestNumber=0;
 const paint=count=>{
  count=Math.max(0,Number(count)||0);badge.textContent=String(count);badge.hidden=count===0;
  link.setAttribute('aria-label',count?`Shopping bag, ${count} ${count===1?'item':'items'}`:'Shopping bag');
 };
 const refresh=async()=>{
  const current=++requestNumber;
  try{
   const response=await originalFetch.call(window,link.dataset.cartStatusUrl,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
   if(!response.ok)return;
   const cart=await response.json();if(current===requestNumber)paint(cart.item_count);
  }catch(error){/* Preserve the server-rendered count when the network is unavailable. */}
 };
 const schedule=()=>{clearTimeout(timer);timer=setTimeout(refresh,150);};
 const mutation=url=>{
  try{return /\/cart\/(add|change|update|clear)(?:\.js|\.json)?$/.test(new URL(url,location.href).pathname);}catch(error){return false;}
 };
 window.fetch=function(input,options){
  const promise=originalFetch.apply(this,arguments);
  if(mutation(typeof input==='string'||input instanceof URL?input:input?.url)){
   return promise.then(response=>{if(response.ok)schedule();return response;});
  }
  return promise;
 };
 const originalOpen=XMLHttpRequest.prototype.open,originalSend=XMLHttpRequest.prototype.send,tracked=new WeakSet();
 XMLHttpRequest.prototype.open=function(method,url){
  if(mutation(url))tracked.add(this);else tracked.delete(this);
  return originalOpen.apply(this,arguments);
 };
 XMLHttpRequest.prototype.send=function(){
  if(tracked.has(this))this.addEventListener('loadend',()=>{if(this.status>=200&&this.status<300)schedule();},{once:true});
  return originalSend.apply(this,arguments);
 };
 ['ajaxProduct:added','ajaxCart:updated','cart:updated','cart:change','cart:refresh'].forEach(event=>document.addEventListener(event,schedule));
 window.addEventListener('pageshow',schedule);window.addEventListener('focus',schedule);
 document.addEventListener('visibilitychange',()=>{if(!document.hidden)schedule();});
 refresh();
})();
/* End shared cart quantity */

/* Storefront search: open the existing predictive-search component in place. */
(()=>{
 const trigger=document.querySelector('[data-ss-search-open]');
 const panel=document.querySelector('#SSHeaderSearch');
 if(!trigger||!panel||trigger.dataset.ssSearchInitialized)return;
 trigger.dataset.ssSearchInitialized='true';
 const header=trigger.closest('.v2-header');
 const input=panel.querySelector('input[type="search"]');
 const close=(notify=true)=>{
  if(panel.hidden)return;
  panel.hidden=true;header.classList.remove('ss-search-open');
  trigger.setAttribute('aria-expanded','false');
  if(notify)document.dispatchEvent(new CustomEvent('predictive-search:close'));
  document.body.classList.remove('predictive-overflow-hidden');
  trigger.focus({preventScroll:true});
 };
 trigger.addEventListener('click',event=>{
  event.preventDefault();
  event.stopImmediatePropagation();
  if(!panel.hidden){close();return;}
  document.querySelector('.mobile-menu-toggle[aria-expanded="true"]')?.click();
  document.querySelector('.rewards-trigger[aria-expanded="true"]')?.click();
  panel.hidden=false;header.classList.add('ss-search-open');
  trigger.setAttribute('aria-expanded','true');
  document.dispatchEvent(new CustomEvent('predictive-search:open',{detail:{context:'header'}}));
  // iOS opens its keyboard only while focus stays in the tap's activation event.
  input.focus({preventScroll:true});
 });
 panel.querySelector('.btn--close-search').addEventListener('click',event=>{event.preventDefault();close();});
 panel.querySelector('[data-screen]').addEventListener('click',()=>close());
 panel.addEventListener('click',event=>event.stopPropagation());
 document.addEventListener('predictive-search:close-all',()=>close(false));
 panel.addEventListener('keydown',event=>{
  if(event.key==='Escape'){event.preventDefault();close();return;}
  if(event.key!=='Tab')return;
  const controls=[...panel.querySelectorAll('input:not([type="hidden"]),button,a[href]')].filter(el=>el.getClientRects().length);
  const first=controls[0],last=controls[controls.length-1];
  if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
  else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
 });
})();
/* End storefront search */

/* Load lower-homepage images near their section, keeping the original URLs. */
function initializeDeferredHomeImages(scope = document) {
 const groups = scope.querySelectorAll('.customer-photo-strip,.builder-grid');
 const waiting = [...groups].filter(group => group.querySelector('[data-ss-home-image]'));
 if (!waiting.length) return;
 const load = group => {
  group.querySelectorAll('[data-ss-home-image]').forEach(image => {
   const srcset = image.getAttribute('data-ss-home-srcset');
   if (srcset) image.setAttribute('srcset', srcset);
   image.setAttribute('src', image.getAttribute('data-ss-home-src'));
   image.removeAttribute('data-ss-home-image');
   image.removeAttribute('data-ss-home-src');
   image.removeAttribute('data-ss-home-srcset');
  });
 };
 if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
  waiting.forEach(load);
  return;
 }
 const pending = new Set(waiting);
 const observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
   if (!entry.isIntersecting || !pending.has(entry.target)) return;
   load(entry.target);
   observer.unobserve(entry.target);
   pending.delete(entry.target);
  });
  if (!pending.size) observer.disconnect();
 }, {rootMargin: '600px 0px'});
 waiting.forEach(group => observer.observe(group));
}
initializeDeferredHomeImages();
document.addEventListener('shopify:section:load', event => initializeDeferredHomeImages(event.target));
